var boostAI_DefaultSortingValue={sorting:"Sorting",sorting_best_selling:"Best Selling",sorting_featured:"Featured",sorting_heading:"Sorting",sorting_manual:"Manual",sorting_relevance:"Relevance",sorting_created_ascending:"Created Ascending",sorting_created_descending:"Created Descending",sorting_date_ascending:"Date Ascending",sorting_date_descending:"Date Descending",sorting_published_descending:"Published Descending",sorting_published_ascending:"Published Ascending",sorting_price_ascending:"Price Ascending",sorting_price_descending:"Price Descending",sorting_sale_ascending:"% Off",sorting_sale_descending:"% Off, Low to High",sorting_title_ascending:"Title Ascending",sorting_title_descending:"Title Descending"};try{if("undefined"!=typeof boostPFSThemeConfig&&boostPFSThemeConfig.hasOwnProperty("label"))for(var key in boostPFSThemeConfig.label){if(boostPFSThemeConfig.label.hasOwnProperty(key)&&"string"==typeof boostPFSThemeConfig.label[key])-1!==(value=boostPFSThemeConfig.label[key].toLowerCase()).indexOf("translation missing")&&void 0!==boostAI_DefaultSortingValue[key]&&(boostPFSThemeConfig.label[key]=boostAI_DefaultSortingValue[key])}if("undefined"!=typeof bcSfFilterConfig&&bcSfFilterConfig.hasOwnProperty("label"))for(var key in bcSfFilterConfig.label){var value;if(bcSfFilterConfig.label.hasOwnProperty(key)&&"string"==typeof bcSfFilterConfig.label[key])-1!==(value=bcSfFilterConfig.label[key].toLowerCase()).indexOf("translation missing")&&void 0!==boostAI_DefaultSortingValue[key]&&(bcSfFilterConfig.label[key]=boostAI_DefaultSortingValue[key])}}catch(e){console.log("Patch defaultSortingValue error")}

var boostPFS = new BoostPFS();
boostPFS.init(); 
if (typeof boostPFSConfig != 'undefined' 
	&& typeof boostPFSConfig.general != 'undefined' 
	&& typeof boostPFSConfig.general.isInitFilter != 'undefined' 
	&& boostPFSConfig.general.isInitFilter === true) { 
	boostPFS.initFilter(); 
} 
BoostPFS.jQ(window).on('load', function(){
	boostPFS.initSearchBox();
	boostPFS.initAnalytics();
});


let handlePageScroll = {
	isReload: false,
	init(){
		var last_url = sessionStorage.getItem('prev_page_url')
		sessionStorage.setItem('prev_page_url',window.location.href)
		console.log(last_url, window.location.href);
		if(last_url==window.location.href){
			// console.log('页面链接没改变，执行定位');
			this.scrollToView()
		}else{
			// console.log('页面链接改变，删除定位值');
			sessionStorage.removeItem('scrollHeight')
		}

		this.listenScrollTop()

	},
	// 滚动到 上次访问位置
	scrollToView(){
		let scrollHeight = sessionStorage.getItem('scrollHeight');

		if(scrollHeight) {
			setTimeout(() => {
				window.scrollTo({
					top: scrollHeight,
					behavior: "smooth"
				});
			}, 300)
		}
	},
	// 监听记录用户滚动位置
	listenScrollTop(){
		const debounce = () => {
			let timer = null;
			return () => {
				if(timer) {
					clearTimeout(timer);
				}
				timer = setTimeout(() => {
					sessionStorage.setItem('scrollHeight', window.pageYOffset ||
					document.body.scrollTop || document.documentElement.scrollTop)
				}, 500)
			}
		}
		this.scrollFn = debounce();
		window.addEventListener('scroll', this.scrollFn)
	},

}

handlePageScroll.init()
